import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueI18n from 'vue-i18n'

import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(datePicker)

import VoerroTagsInput from '@voerro/vue-tagsinput';
import '@voerro/vue-tagsinput/dist/style.css'
Vue.component('tags-input', VoerroTagsInput);


Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('title', function (value) {
  if (!value) return ''
  value = value.toString().replace(/_/g, ' ')
  return value.charAt(0).toUpperCase() + value.slice(1)
})

import _ from 'lodash'
import {texts} from './messages'
import {errorCodes} from './error-codes'
const messages = _.merge(texts, errorCodes)

export const i18n = new VueI18n({
  locale: 'en',
  messages
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n
})
